import React from 'react';
import Button from 'screens/components/basic/Button';
import SelectInput from 'screens/components/basic/SelectInput';
import LOOKUP from 'constants/lookup';
import DatePickerInput from 'screens/components/basic/DatePickerInput';
import VisibilityIcon from '@mui/icons-material/Visibility';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import TextInput from 'screens/components/basic/TextInput';
import CardSimple from 'screens/components/basic/CardSimple';
import BranchMultiSelectAutoCompleteInput from 'screens/components/basic/BranchMultiSelectAutoCompleteInput';

const componentName = "DiscountReport";

const Header = (props) => (
    <CardSimple className="p-1">
        <div className="row row_margin_none">
            <div className="col-xs-6 col-sm-3 col-md-4">
                <DatePickerInput
                    name={componentName + LOOKUP.report.common.beginDate.name}
                    floatingLabelText={LOOKUP.report.common.beginDate.label + "*"}
                    hintText={LOOKUP.report.common.beginDate.label + "*"}
                    fullWidth={true}
                    required
                />
            </div> {/* .col */}
            <div className="col-xs-6 col-sm-3 col-md-4">
                <DatePickerInput
                    name={componentName + LOOKUP.report.common.endDate.name}
                    floatingLabelText={LOOKUP.report.common.endDate.label + "*"}
                    hintText={LOOKUP.report.common.endDate.label + "*"}
                    fullWidth={true}
                />
            </div> {/* .col */}
            <div className="col-xs-12 col-sm-6 col-md-4">
                <BranchMultiSelectAutoCompleteInput
                    defaultValues={localStorage.getItem("DiscountReportBranchIds") != null ? localStorage.getItem("DiscountReportBranchIds").split(",").map(item => { return ({ value: item }) }) : props.branchOptions.filter(item => item.value === props.loggedBranch.toString())}
                    name={`${componentName}BranchIds`}
                    fullWidth={true}
                    autoWidth={true}
                    label="Branches"
                    floatingLabelText="Branches"
                    hintText="Branches"
                    style={{ fontFamily: "Open Sans, Arial, Helvetica, sans-serif", fontSize: "16px", letterSpacing: "-0.25px" }}
                    options={props.branchOptions}
                    fieldName={'Branches'}
                />
            </div> {/* .col */}
            <div className="col-xs-12 col-sm-6 col-md-4">
                <TextInput
                    name={componentName + LOOKUP.report.common.employeeFirstName.name}
                    fullWidth={true}
                    label={LOOKUP.report.common.employeeFirstName.label}
                    floatingLabelText={LOOKUP.report.common.employeeFirstName.label}
                    hintText={LOOKUP.report.common.employeeFirstName.label}
                />
            </div>
            <div className="col-xs-12 col-sm-6 col-md-4">
                <TextInput
                    name={componentName + LOOKUP.report.common.employeeLastName.name}
                    fullWidth={true}
                    label={LOOKUP.report.common.employeeLastName.label}
                    floatingLabelText={LOOKUP.report.common.employeeLastName.label}
                    hintText={LOOKUP.report.common.employeeLastName.label}
                />
            </div>
            <div className="col-xs-12 col-sm-6 col-md-4">
                <SelectInput
                    name={componentName + LOOKUP.report.common.orderType.name}
                    fullWidth={true}
                    defaultValue={"0"}
                    label={LOOKUP.report.common.orderType.label + "*"}
                    floatingLabelText={LOOKUP.report.common.orderType.label + "*"}
                    hintText={LOOKUP.report.common.orderType.label + "*"}
                    options={LOOKUP.report.discountReport.orderTypeOptions}
                    required
                />
            </div>
        </div>
        <div className="row">
            <div className="col-lg-12 pt-2 pull-right">
                <Button
                    type="IconInButton"
                    className="pull-right ml-1 btnNewBrandPOS"
                    name={componentName + LOOKUP.report.common.viewReport.name}
                    label={LOOKUP.report.common.viewReport.label}
                    icon={<VisibilityIcon />}
                    onTouchTap={props.showBody}
                />
                <Button
                    type="DownloadButton"
                    className="pull-right btnNewBrandPOS"
                    name={componentName + LOOKUP.report.common.downloadReport.name}
                    label={LOOKUP.report.common.downloadReport.label}
                    onTouchTap={props.download}
                />
            </div>
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                {/* <p className='purpleText'><b>Note: </b><strong className="blue-text"><i>.</i></strong></p> */}
            </div>
        </div>
    </CardSimple>
);

export default Header;
